import TemplateActions from 'notebook/entry-templates/TemplateActions';
import TemplateDAO from 'notebook/entry-templates/TemplateDAO';

/** Creates a draft from a published template version and opens the draft. */
export default async function createTemplateDraftFromVersion(
  templateId: string,
  versionApiId: string
): Promise<void> {
  const result = await TemplateDAO.createDraftFromVersion(templateId, versionApiId);
  if (result) {
    TemplateActions.loadVersion(templateId, result.draftTemplateVersionDbId);
    TemplateActions.fetchVersions(templateId);
    TemplateActions.refreshReviewState(templateId);
  }
}
